import urljoin from 'url-join';

export const getFullPathName = (path: string): string => {
  if (path.split('/').some((name) => ['.', '..'].includes(name))) {
    throw new Error('Contains some unusable directory names.');
  }

  if (path.match(/^(?:[a-z][a-z0-9+\-.]*:|\/\/)/i)) {
    return path;
  }

  if (path.match(/^~\//)) {
    return urljoin(window.aerith.applicationRoot || '/', path.replace(/^~\//, ''));
  }

  if (window.aerith.isPrimarySite) {
    return urljoin(window.aerith.applicationRoot || '/', path);
  } else {
    return urljoin(window.aerith.primarySiteRoot || '/', path);
  }
};
